import React, { useState, useRef, useEffect } from 'react'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import { GetTeams, Profile, UpdateProfile } from '../../API/auth'
import { avalibleSlotsAPI, RemoveAllPlayerWaitlist,changeTeamModalSubmit } from '../../API/player'
import Loader from '../admin/Common/Loader'
import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'

import {
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormInput,
  CForm,
  CRow,
  CCol
} from '@coreui/react'
import { FontSize } from 'ckeditor5'
const ChangeTeamModal = ({
  visible,
  onClose,
  sport,
  onSubmitSuccess,
  slotIdValue
}) => {
  console.log('inside team chaning modal')
  console.log('SPort', sport)
  console.log('visible', visible)

  // const [visible, setVisible] = useState(false)
  const [teams, setTeams] = useState([])
  const [SelectedTeam, setSelectedTeam] = useState(null)
  const [profile, setProfile] = useState(null)
  const [slotStatus, setSlotStatus] = useState(false)
  const [loaderStatus, setloaderStatus] = useState(false)
  let navigate = useNavigate()
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  useEffect(() => {
    let callAPI = async () => {
      let res = await Profile()
      if (res.status) {
        console.log(res.data.profile_image)
        setProfile(res.data)
      }
    }

    callAPI()
  }, [])
  useEffect(() => {
    const getTeamsAPI = async () => {
      try {
        console.log('Team API', profile.city)
        let res = await GetTeams(profile.city)
        setTeams(res.data)
        setSelectedTeam(res.data[0].domain)
        console.log(res.data)
      } catch (error) {
        console.error('Error fetching teams:', error)
      }
    }

    if (profile != null) {
      console.log('inside if  API', profile.corporate_email)

      getTeamsAPI()
    }
  }, [profile])

  useEffect(() => {
    let avalibleSlots = async () => {
      setloaderStatus(true)
      let formData = {
        team: SelectedTeam,
        gender: true
      }
      let res = await avalibleSlotsAPI(formData)
      console.log('responseee', res.data)
      if (res.status) {
        setloaderStatus(false)
        console.log(res.data.TotalResult.badminton)
        if (sport == 'badminton') {
          res.data.TotalResult.badminton > 0
            ? setSlotStatus(true)
            : setSlotStatus(false)
        }

        if (sport == 'tennis') {
          res.data.TotalResult.table_tenis > 0
            ? setSlotStatus(true)
            : setSlotStatus(false)
        }

        if (sport == 'bowling') {
          res.data.TotalResult.bowling > 0
            ? setSlotStatus(true)
            : setSlotStatus(false)
        }

        if (sport == 'twok_run') {
          res.data.TotalResult.twok_run > 0
            ? setSlotStatus(true)
            : setSlotStatus(false)
        }
        // if (res.data.TotalResult.badminton > 0) {
        //   console.log('in 0 igger')
        //   SetSelectBatminton({
        //     title: 'Avalible',
        //     value: res.data.TotalResult.badminton,
        //     style: {
        //       color: 'rgba(23, 92, 30, 1)',
        //       fontFamily: 'Roboto',
        //       border: '1px solid rgba(23, 92, 30, 1)'
        //     }
        //   })
        //   setBadmintionSlot(res.data.TotalResult.badminton)
        //   setLogoutCount(logoutCount + 1)
        // }
        // if (res.data.TotalResult.badminton == 0) {
        //   console.log('in 0 smaller badmintion')

        //   SetSelectBatminton({
        //     title: 'Unavalible',
        //     value: res.data.TotalResult.badminton,
        //     style: {
        //       color: 'rgba(23, 92, 30, 1)',
        //       fontFamily: 'Roboto',
        //       border: '1px solid rgba(23, 92, 30, 1)'
        //     }
        //   })
        //   setBadmintionSlot(res.data.TotalResult.badminton)
        //   setWaitListActive(prevState => ({
        //     ...prevState,
        //     badminton: {
        //       waitList: true,
        //       sport: 'badminton',
        //       round: 'group_stage'
        //     }
        //   }))
        // }
        // if (res.data.TotalResult.table_tenis > 0) {
        //   SetSelectTableTenis({
        //     title: 'Avalible',
        //     value: res.data.TotalResult.table_tenis,
        //     style: {
        //       color: 'rgba(23, 92, 30, 1)',
        //       fontFamily: 'Roboto',
        //       border: '1px solid rgba(23, 92, 30, 1)'
        //     }
        //   })
        //   setTableTenniSlot(res.data.TotalResult.table_tenis)
        //   setLogoutCount(logoutCount + 1)
        // }
        // if (res.data.TotalResult.table_tenis == 0) {
        //   SetSelectTableTenis({
        //     title: 'Unavalible',
        //     value: res.data.TotalResult.table_tenis,
        //     style: {
        //       color: 'rgba(23, 92, 30, 1)',
        //       fontFamily: 'Roboto',
        //       border: '1px solid rgba(23, 92, 30, 1)'
        //     }
        //   })
        //   setTableTenniSlot(res.data.TotalResult.table_tenis)
        //   setWaitListActive(prevState => ({
        //     ...prevState,
        //     table_tenis: {
        //       waitList: true,
        //       sport: 'table_tenis',
        //       round: 'group_stage'
        //     }
        //   }))
        // }

        // //bowling
        // if (res.data.TotalResult.bowling > 0) {
        //   SetSelectBowling({
        //     title: 'Avalible',
        //     value: res.data.TotalResult.bowling,
        //     style: {
        //       color: 'rgba(23, 92, 30, 1)',
        //       fontFamily: 'Roboto',
        //       border: '1px solid rgba(23, 92, 30, 1)'
        //     }
        //   })
        //   setBowlingSlot(res.data.TotalResult.bowling)
        //   setLogoutCount(logoutCount + 1)
        // }

        // if (res.data.TotalResult.bowling == 0) {
        //   console.log('Bowling is 0')

        //   SetSelectBowling({
        //     title: 'Unavalible',
        //     value: res.data.TotalResult.bowling,
        //     style: {
        //       color: 'rgba(23, 92, 30, 1)',
        //       fontFamily: 'Roboto',
        //       border: '1px solid rgba(23, 92, 30, 1)'
        //     }
        //   })
        //   setBowlingSlot(res.data.TotalResult.bowling)
        //   setWaitListActive(prevState => ({
        //     ...prevState,
        //     bowling: {
        //       waitList: true,
        //       sport: 'bowling',
        //       round: 'round_1'
        //     }
        //   }))
        // }

        // //2k_run
        // if (res.data.TotalResult.twok_run > 0) {
        //   SetSelect2k_run({
        //     title: 'Avalible',
        //     value: res.data.TotalResult.twok_run,
        //     style: {
        //       color: 'rgba(23, 92, 30, 1)',
        //       fontFamily: 'Roboto',
        //       border: '1px solid rgba(23, 92, 30, 1)'
        //     }
        //   })
        //   settwokRuniSlot(res.data.TotalResult.twok_run)
        //   setLogoutCount(logoutCount + 1)
        // }
        // if (res.data.TotalResult.twok_run == 0) {
        //   SetSelect2k_run({
        //     title: 'Unavalible',
        //     value: res.data.TotalResult.twok_run,
        //     style: {
        //       color: 'rgba(23, 92, 30, 1)',
        //       fontFamily: 'Roboto',
        //       border: '1px solid rgba(23, 92, 30, 1)'
        //     }
        //   })
        //   settwokRuniSlot(res.data.TotalResult.twok_run)
        //   setWaitListActive(prevState => ({
        //     ...prevState,
        //     twok_run: {
        //       waitList: true,
        //       sport: '2k_run',
        //       round: 'round_1'
        //     }
        //   }))
        // }
      }
    }

    if (SelectedTeam != null) {
      avalibleSlots()
    }
  }, [SelectedTeam])
  let handleTeamChange = e => {
    setSelectedTeam(e.target.value)
  }

  let handleSubmit = async () => {
    if (profile.corporate_email === SelectedTeam) {
      enqueueSnackbar(
        'You are already associated with selected team, please select another team',
        {
          variant: 'error',
          action: key => (
            <button
              className='toast_close_btn'
              onClick={() => {
                // Close the Snackbar
                closeSnackbar(key)
              }}
            >
              X
            </button>
          )
        }
      )
    } else {
      let formData ={
        "document_id" :slotIdValue
      }
      let res = await changeTeamModalSubmit(formData)
      if (res.data.status) {
        onSubmitSuccess(true, SelectedTeam)
      }  else {
        console.log(res);
        onSubmitSuccess(false, SelectedTeam)

      }
      // enqueueSnackbar("Team changed successfully", { variant: 'success' });
      onClose(!visible)
      // console.log("changing team")
      // let formData = {
      //   id : profile.id,
      //   corporate_email : SelectedTeam
      // }
      // let res = await UpdateProfile(formData);
      // if (res.data.status) {
      //   // delete all the entry in waiting list for this player
      //   let EmptyData ={
      //     data: null
      //   }
      //   let deleteAllWaitlist = await RemoveAllPlayerWaitlist(EmptyData)
      //   enqueueSnackbar("Team changed successfully", { variant: 'success' });
      //   onClose(!visible)
      // } else {
      //   enqueueSnackbar(res.data.message, { variant: 'error' });
      // }
    }
  }

  function toTitleCase (str) {
    console.log("str", str);
    return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())
  }
  function getGame (game) {
    let finalValue =
      game == 'badminton'
        ? 'Badminton'
        : game == 'tennis'
        ? 'Table Tennis'
        : game == 'bowling'
        ? 'Bowling'
        : game == 'twok_run'
        ? '2k Run'
        : 'N/A'
    return finalValue
  }
  return (
    <>
      {loaderStatus ? <Loader /> : null}

      <CModal
        alignment='center'
        visible={visible}
        onClose={() => onClose(false)}
        aria-labelledby='VerticallyCenteredExample'
      >
        <CModalHeader>
          <CModalTitle id='VerticallyCenteredExample'>Confirm Team Enrollment</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CRow>
            <CCol sm={8} md={8} lg={8}>
              <div className='mb-3'>
                {teams.length > 0 ? (
                  <>
                    <label
                      className='mb-2 input-label text-dark'
                      htmlFor='corporateEmail'
                      style={{fontSize:'14px'}}
                    >
                    Please choose the team with an available slot:
                    </label>

                    <select
                      name='corporateEmail'
                      className='mb-4 form-select'
                      onChange={e => handleTeamChange(e)}
                      // style={{ background: '#fff' ,width:'100%'}}
                      value={SelectedTeam}    
                      required
                    >
                      <option className='text-dark' value='' disabled>
                        Select a Team
                      </option>
                      {teams.map((entry, index) => (
                        <option
                          className='text-dark'
                          key={index}
                          value={entry.domain}
                        >
                          {toTitleCase(entry.domain)}
                        </option>
                      ))}
                    </select>
                  </>
                ) : null}
              </div>
            </CCol>

            <CCol>
              <div>
                <label for='exampleInputEmail1' class='form-label' 
                      style={{fontSize:'14px'}}
                
                >
                  Slot status
                </label>
                <br></br>
                {slotStatus ? (
                  <button className='btn btn-success text-white '
                  >
                    Available
                  </button>
                ) : (
                  <button
                    className='btn btn-secondary  disabled'
                    style={{
                      backgroundColor: '#d3d3d3',
                      border: 'none',
                      color: 'rgb(12 8 8)',
                    }}
                  >
                    Not Available{' '}
                  </button>
                )}
              </div>
            </CCol>
          </CRow>

          {profile != null  && SelectedTeam != null ? (
            <>
              <p className='text-warning'style={{fontSize:'14px'}}>
                {' '}
                You are currently on the waitlist for {getGame(sport)} with the {toTitleCase(profile.corporate_email)}, and a spot has become available with a different team. Would you like to confirm your enrollment? Please note that confirming your enrollment will remove you from any other sport waitlists for the  {toTitleCase(profile.corporate_email)}.

              </p>
            </>

          ) : null}
        </CModalBody>
        <CModalFooter>
          <CButton
            color='btn btn-secondary'
            onClick={() => navigate('/dashboard')}
          >
            Continue with current Team
          </CButton>
          <CButton
            color='btn btn-danger text-white'
            onClick={() => handleSubmit()}
            disabled={slotStatus == false ? true : false}
          >
            Change Team
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}
export default ChangeTeamModal
